<template>
  <div class="w-full mt-6 space-y-12 lg:flex lg:gap-x-6 lg:space-y-0 h-fit">
    <div class="relative h-[391px] lg:h-[566px] lg:w-1/3 flex-col">
      <div class="w-full h-full border border-secondary-300/40 rounded-xl">
        <div class="border-b border-secondary-300/40">
          <div class="ml-4 my-4 h-4 w-48 bg-neutral-600/40 rounded-xl"></div>
        </div>
      </div>
    </div>
    <div class="lg:w-2/3 flex flex-col justify-start gap-6">
      <div
        class="w-full h-28 lg:h-full border border-secondary-300/40 rounded-xl">
        <div class="border-b border-secondary-300/40">
          <div class="ml-4 my-4 h-4 w-48 bg-neutral-600/40 rounded-xl"></div>
        </div>
      </div>
      <div
        class="w-full h-28 lg:h-full border border-secondary-300/40 rounded-xl">
        <div class="border-b border-secondary-300/40">
          <div class="ml-4 my-4 h-4 w-48 bg-neutral-600/40 rounded-xl"></div>
        </div>
      </div>
      <div
        class="w-full h-28 lg:h-full border border-secondary-300/40 rounded-xl">
        <div class="border-b border-secondary-300/40">
          <div class="ml-4 my-4 h-4 w-48 bg-neutral-600/40 rounded-xl"></div>
        </div>
      </div>
      <div
        class="w-full h-28 lg:h-full border border-secondary-300/40 rounded-xl">
        <div class="border-b border-secondary-300/40">
          <div class="ml-4 my-4 h-4 w-48 bg-neutral-600/40 rounded-xl"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-6 w-full flex flex-wrap sm:flex-nowrap gap-6"></div>
</template>
